import { COLOR_PALETTE, Checkbox, Group, Input, Text } from '@inflearn/ds-react';
import type { MantineSize } from '@mantine/core';
import { debounce } from 'lodash-es';
import type { ReactNode } from 'react';

interface CheckboxCardProps {
  label?: string;
  description?: ReactNode;
  checked: boolean;
  required?: boolean;
  onClick?: () => void;
  size?: MantineSize;
  children?: ReactNode;
}

export const CheckboxCard = ({
  label,
  description,
  checked,
  required = false,
  onClick = () => null,
  size = 'md',
  children,
}: CheckboxCardProps) => {
  return (
    <Input.Wrapper size={size} w="100%" css={{ cursor: 'pointer' }}>
      <Input.Label size={size} required={required}>
        {label}
      </Input.Label>
      <Input.Description size={size}>{description}</Input.Description>
      <Group
        spacing="xs"
        p={8}
        mt={8}
        align="center"
        css={{ borderRadius: 8, border: `1px solid ${COLOR_PALETTE.gray[3]}` }}
        onClick={debounce(onClick, 100)}
      >
        <Checkbox
          size={size}
          checked={checked}
          label={
            <Text size={size} fw={600}>
              {children}
            </Text>
          }
        />
      </Group>
    </Input.Wrapper>
  );
};
